import { useEffect } from "react";
import { useAppSelector } from "../../stateManagement/hooks/redux";
import { getItemWebStorage } from "../../features/webStorageSaver";
import { useGetWeatherStationsByCustomerCodeQuery, WeatherStation } from "../../api/rtk/weatherStations/slices/weatherStationsApiSlice";

export function useWeatherStations(): { weatherStations?: [WeatherStation], isFetching: boolean } {
    const currentConfig = getItemWebStorage('currentConfig');
    const workspace = currentConfig?.workspace;

    const token = useAppSelector(state => state.auth.tokens.services?.weatherStations)

    const { data: weatherStations, isFetching, refetch } =
        useGetWeatherStationsByCustomerCodeQuery(
            { customerCode: workspace },
            { skip: !token }
        )

    useEffect(() => {
        if (token) refetch();
    }, [token, refetch])

    return { weatherStations, isFetching };
}